import React from 'react'
import PropTypes from 'prop-types'
import Modal, { Header, Main, Footer } from 'li-components/lib/Modal2'
import Button from 'li-components/lib/next/Button'

const RightsAgreement = ({ show, onAgree, onDecline }) => (
  <Modal isOpen={show} onBackdropClick={() => {}}>
    <Header>
      <h1 style={{ margin: 0 }}>Limited Rights Agreement</h1>
    </Header>
    <Main style={{ margin: 0, padding: '1rem 4rem' }}>
      <p style={{ fontWeight: 400, margin: 0 }}>
        In accordance with Government Contract No.HHSF223201510043I, all data
        generated by Label Insight being accessed through this portal, is made
        available only to the FDA and with only Limited Rights. The FDA may
        reproduce and use the accessed data within the FDA only for the purposes
        set forth in the Contract and with the express limitation that the FDA
        will not, without the prior express written consent of Label Insight,
        disclose any of the data to anyone outside the FDA; provided, however,
        that in the event Label Insight authorizes the FDA to make a third-party
        disclosure outside the FDA then the FDA may make such disclose of the
        data for the agreed upon purposes to the agreed upon recipient only and
        with the limitation that the FDA makes such disclosure subject to a
        strict prohibition against further use and disclosure.
      </p>
    </Main>
    <Footer style={{ textAlign: 'right' }}>
      <Button onClick={onDecline}>Decline</Button>{' '}
      <Button kind="primary" onClick={onAgree}>
        Agree
      </Button>
    </Footer>
  </Modal>
)

RightsAgreement.propTypes = {
  show: PropTypes.bool.isRequired,
  onAgree: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
}

export default RightsAgreement



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/RightsAgreement.js